export const formatBRL = (value) => {
    if (value == null || isNaN(value)) return '—';
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

export const formatPercent = (value) => {
    if (value == null || isNaN(value)) return '—';
    return (value * 100).toFixed(2).replace('.', ',') + '%';
};
